import PropTypes from 'prop-types';

import Grid from '@mui/material/Grid';

import {
  CurrentProgressText, StatusGrid, Button, Container
} from './component.styles';

const ProgressBar = ({
  steps, progress, current, onClick
}) => {
  const currentProgress = Math.max(Math.min(steps, progress), 0);
  const currentStep = Math.max(Math.min(steps, current), 0);
  const listOfSteps = Array.from(Array(steps).keys());
  return (
    <Container>
      <Grid
        container
        spacing={0}
        sx={{
          alignItems: 'center',
          height: '1rem'
        }}
      >
        {listOfSteps.map((step) => {
          let status = 'pending';
          let isClickable = false;
          if (step === currentStep) {
            status = 'current';
          } else if (step < currentProgress) {
            status = 'completed';
            isClickable = true;
          } else if (step === currentProgress) {
            status = 'pending-clickable';
            isClickable = true;
          }
          return (
            <StatusGrid
              step={step}
              currentStep={currentStep}
              currentProgress={currentProgress}
              key={step}
              item
              xs
              data-testid={`progressbar-${status}-step`}
            >
              <Button
                disabled={!isClickable}
                onClick={() => onClick(step)}
              />
            </StatusGrid>
          );
        })}
        <CurrentProgressText size="sm" tag="span">
          {`${currentProgress} of ${steps}`}
        </CurrentProgressText>
      </Grid>
    </Container>
  );
};

ProgressBar.defaultProps = {
  onClick: () => {}
};

ProgressBar.propTypes = {
  steps: PropTypes.number.isRequired,
  progress: PropTypes.number.isRequired,
  current: PropTypes.number.isRequired,
  onClick: PropTypes.func
};

export default ProgressBar;
